/**
 * Extract all data-wrm-key attribute values from webresource.tags.js.
 * Handles script tags like <script ... data-wrm-key="confluence.web.resources:event" ...></script>
 * and returns a string[] of the keys (e.g. ["confluence.web.resources:event", "confluence.web.resources:connect-helper", ...]).
 */
export const parseWrmKeysFromTagsJs = (tagsJs: string | null | undefined): string[] => {
	if (!tagsJs || typeof tagsJs !== 'string') {
		return [];
	}
	const keys: string[] = [];
	const pattern = /data-wrm-key=["']([^"']+)["']/g;
	let match: RegExpExecArray | null;
	while ((match = pattern.exec(tagsJs)) !== null) {
		keys.push(match[1]);
	}
	return keys;
};
